import PropTypes from "prop-types";
import { memo } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import styles from './DragAndDrop.module.scss';
import SortableItem from "./SortableItem";

const DragAndDropContext = ({
  containers,
  nameSuffix="",
  TopContainers=[],
  nonRemovableTabs=[],
  onDragEnd=() => {},
  getbordercolor,
  getBackgroundColor,
  isTabSelected,
  changeFunc,
  isEditClicked,
  selectedTabs,
  draggedId=null,
  sourceId=null,
  draggedObject=[],
  tabs,
  isNoDataMsg="",
}) => {
  const isTabAllowed = (container) =>
    selectedTabs.includes("All") || selectedTabs.includes(container);

  const findContainerByPolicyName = (containers, policyName) => {
    for (const [containerKey, items] of Object.entries(containers)) {
      const foundItem = items.find((item) => item.policyName === policyName);
      if (foundItem) {
        if (
          selectedTabs.includes("All") ||
          selectedTabs.includes(containerKey)
        ) {
          return false;
        }
        return true;
      }
    }
    return true;
  };

  return (
    <DragDropContext onDragEnd={isEditClicked ? onDragEnd : undefined}>
      <div>
        {/* Static Container */}

        {Object.keys(containers)
          .filter((container) => TopContainers.includes(container))
          .map((container) => (
            <div
              key={container}
              className={styles.uncategorized}
              style={{
                border: `2px solid ${getbordercolor(container)}`,
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  cursor: isTabAllowed(container) ? "pointer" : "not-allowed",
                }}
              >
                <h4 className={styles.policyName}>{container}</h4>
              </div>
              <Droppable droppableId={container}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={`${styles.uncategorizedContainer}`}
                    style={{
                      opacity:
                        isTabSelected(container) || isTabSelected("All")
                          ? 1
                          : 0.3,
                      cursor: isTabAllowed(container)
                        ? "pointer"
                        : "not-allowed",
                    }}
                  >
                    <div className={styles.dragDropPart}>
                      {containers[container].length === 0 ? (
                        <div className={styles.emptyPolicys}>{isNoDataMsg}</div>
                      ) : (
                        containers[container].map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                            isDragDisabled={
                              !isEditClicked ||
                              findContainerByPolicyName(
                                containers,
                                item.policyName
                              )
                            }
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  margin: "2px",
                                }}
                              >
                                <SortableItem
                                  item={item}
                                  id={item.id}
                                  category={container}
                                  name={item.policyName}
                                  bordercolor={getbordercolor(container)}
                                  BackgroundColor={getBackgroundColor(
                                    container
                                  )}
                                  changeFunc={changeFunc}
                                  isEditClicked={isEditClicked}
                                  draggedId={draggedId}
                                  sourceId={sourceId}
                                  draggedObject={draggedObject}
                                  selectedTabs={selectedTabs}
                                  nonRemovableTabs={nonRemovableTabs}
                                  tabs={tabs}
                                />
                              </div>
                            )}
                          </Draggable>
                        ))
                      )}
                    </div>
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          ))}

        {/* Other Containers */}
        <div className="container-fluid ">
          <div className="row">
            {Object.keys(containers)
              .filter((container) => !TopContainers.includes(container))
              .map((container) => (
                <div
                  key={container}
                  className={`custom_scroll ${styles.containerColumn}`}
                  style={{
                    opacity:
                      isTabSelected(container) || isTabSelected("All")
                        ? 1
                        : 0.3,
                    border: `2px solid ${getbordercolor(container)}`,
                    cursor: isTabAllowed(container) ? "pointer" : "not-allowed",
                  }}
                >
                  <h4 className={styles.policyName}>{`${container} ${nameSuffix}`}</h4>
                  <Droppable droppableId={container}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`${styles.otherContainer} p-0 `}
                      >
                        <div className={styles.dragDropPart}>
  {!containers?.[container] || (containers[container] ?? []).length === 0 ? (
    <div
      className={styles.emptyPolicys}
      style={{ marginTop: "90px" }}
    >
      {isNoDataMsg}
    </div>
  ) : (
    (containers[container] ?? []).map((item, index) => (
      <Draggable
        key={item.id}
        draggableId={item.id?.toString() ?? index.toString()}
        index={index}
        isDragDisabled={
          !isEditClicked ||
          findContainerByPolicyName(containers, item.policyName)
        }
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...provided.draggableProps.style,
              margin: "2px",
            }}
          >
            <SortableItem
              item={item}
              id={item.id}
              category={container}
              name={item.policyName}
              bordercolor={getbordercolor(container)}
              BackgroundColor={getBackgroundColor(container)}
              changeFunc={changeFunc}
              isEditClicked={isEditClicked}
              severity={item.severity}
              draggedId={draggedId}
              sourceId={sourceId}
              draggedObject={draggedObject}
              selectedTabs={selectedTabs}
              nonRemovableTabs={nonRemovableTabs}
              tabs={tabs}
            />
          </div>
        )}
      </Draggable>
    ))
  )}
</div>

                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </div>
              ))}
          </div>
        </div>
      </div>
    </DragDropContext>
  );
};

DragAndDropContext.propTypes = {
  containers: PropTypes.object.isRequired,
  ContainerKey: PropTypes.string.isRequired,
  onDragEnd: PropTypes.func,
  getbordercolor: PropTypes.func.isRequired,
  getBackgroundColor: PropTypes.func.isRequired,
  isTabSelected: PropTypes.func.isRequired,
  changeFunc: PropTypes.func.isRequired,
  isEditClicked: PropTypes.bool.isRequired,
  selectedTabs: PropTypes.array.isRequired,
  draggedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sourceId: PropTypes.string,
  nameSuffix: PropTypes.string,
  isNoDataMsg: PropTypes.string,
  draggedObject: PropTypes.array,
  nonRemovableTabs: PropTypes.array,
  TopContainers: PropTypes.array,
  tabs: PropTypes.array,
};


export default memo(DragAndDropContext);
